import React, { PureComponent } from "react";

import { connect } from "react-redux";
import { Query } from "react-apollo";
import { Redirect } from "react-router-dom";
import styled from "styled-components";

import Loading from "../components/Loading/Loading";
import AdminForm from "../components/AdminForm/AdminForm";
import Header from "../components/Header/Header";
import Menu from "../components/Menu";

import partyByCodeQuery from "../queries/partyByCodeQuery.gql";

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  position: relative;
  flex-grow: 2;
`;

const Inner = styled.div`
  max-width: 960px;
  margin: 100px auto;
`;

class Admin extends PureComponent {
  render() {
    const { code } = this.props;

    if (!code) return <Redirect to="/reset?wrongcode=1" />;

    return (
      <Query query={partyByCodeQuery} variables={{ code }}>
        {({ loading, error, data }) => {
          if (loading) return <Loading />;
          if (error) return <Redirect to="/reset/1" />;

          return (
            <PageWrapper>
              <Header />
              <Content>
                <Menu />
                <Inner>
                  <AdminForm {...data.party} history={this.props.history} />
                </Inner>
              </Content>
            </PageWrapper>
          );
        }}
      </Query>
    );
  }
}

const mapStateToProps = state => {
  return {
    code: state.code
  };
};

export default connect(mapStateToProps)(Admin);



// WEBPACK FOOTER //
// ./src/pages/Admin.js